export const formatBulkResolvePersonNameOnly = (row: {
    firstName?: string;
    middleName?: string;
    lastName?: string;
}): string => [row.firstName, row.middleName, row.lastName].filter(Boolean).join(" ");

export const formatBulkResolvePersonName = (row: {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    affiliationAbbrev?: string;
}): string => {
    const name = formatBulkResolvePersonNameOnly(row);
    const abbr = row.affiliationAbbrev ?? "";
    return abbr ? `${name} | ${abbr}` : name;
};

export const formatMoveToChoiceLabel = (targetStatus: string): string | null =>
    targetStatus ? `Move to ${targetStatus}` : null;

export type SosCommentDisplayBlock = {
    label: string;
    text: string;
};

export const buildSosCommentDisplayBlocks = (
    sosComment?: string,
    sentToSosComment?: string,
): SosCommentDisplayBlock[] => {
    const sos = sosComment?.trim() || "";
    const sentToSos = sentToSosComment?.trim() || "";

    if (!sos && !sentToSos) {
        return [];
    }
    if (sos && sentToSos && sos === sentToSos) {
        return [{ label: "SOS / Sent to SOS", text: sos }];
    }
    const blocks: SosCommentDisplayBlock[] = [];
    if (sos) {
        blocks.push({ label: "SOS", text: sos });
    }
    if (sentToSos) {
        blocks.push({ label: "Sent to SOS", text: sentToSos });
    }
    return blocks;
};
